export class ConselhoDTO {
    sigla: string;
    especialidades: string[];
}
